module.exports = __webpack_public_path__ + "media/4.b402ee09.wav";